import { onMounted, unref, ref } from 'vue'
import { throttle } from 'lodash'
export default function useHover (bodyRef) {
  const hoveredKrId = ref(undefined)
  onMounted(() => {
    bind()
  })

  const onmousemoveHandler = throttle(e => {
    const rowId = e.target.attributes?.rowid?.value || e.target.parentElement.attributes?.rowid?.value
    if (!rowId) {
      return
    }
    hoveredKrId.value = rowId
  }, 200)

  const removeBodyHoverEventListener = () => {
    const body = unref(bodyRef)
    body.removeEventListener('mousemove', onmousemoveHandler)
    hoveredKrId.value = undefined
  }

  const addBodyHoverEventListener = () => {
    const body = unref(bodyRef)
    body.addEventListener('mousemove', onmousemoveHandler)
  }

  const bind = () => {
    const body = unref(bodyRef)
    body.addEventListener('mouseenter', () => {
      addBodyHoverEventListener()
    })
    body.addEventListener('mouseleave', () => {
      removeBodyHoverEventListener()
    })
  }

  return {
    hoveredKrId,
    removeBodyHoverEventListener,
    addBodyHoverEventListener
  }
}
